import React from 'react';

interface IToggleFieldProps {
  labelText: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id: string;
  name: string;
  disabled?: boolean;
}

const ToggleField: React.FC<IToggleFieldProps> = ({
  checked,
  disabled,
  id,
  labelText,
  name,
  onChange,
}) => {
  // const status = checked ? 'Enabled' : 'Disabled';

  return (
    <div className="field-row">
      <label
        className="field-label"
        htmlFor={id}
      >
        {labelText}
      </label>
      <div className="toggle-container">
        <label
          className="toggle-switch"
          htmlFor={id}
        >
          <input
            checked={checked}
            className="toggle-input"
            disabled={disabled}
            id={id}
            name={name}
            onChange={onChange}
            type="checkbox"
          />
          <span className="toggle-slider" />
        </label>
        {/* <span className="status-indicator-label">
          <span className={`status-indicator ${checked ? 'enabled' : 'disabled'}`}>
            {status}
          </span>
        </span> */}
      </div>
    </div>
  );
};

export default ToggleField;
